import { NewShopifyImpl } from './newShopifyImpl.js';

export class ShopifyService {
  constructor() {
    this.impl = new NewShopifyImpl();
  }

  getCheckout(isFromWebapp, callback, attempt) {
    return this.impl.getCheckout(isFromWebapp, callback, attempt);
  }

  createCheckout(callback) {
    return this.impl.createCheckout(callback);
  }

  applyDiscount(checkoutId, discountCode, callback) {
    return this.impl.applyDiscount(checkoutId, discountCode, callback);
  }

  getCollection(collectionId) {
    return this.impl.getCollection(collectionId);
  }

  addLineItems(checkoutId, lineItems) {
    return this.impl.addLineItems(checkoutId, lineItems);
  }

  updateLineItems(checkoutId, lineItems) {
    return this.impl.updateLineItems(checkoutId, lineItems);
  }

  getProduct(productId) {
    return this.impl.getProduct(productId);
  }

  cleanCheckout() {
    return this.impl.cleanCheckout();
  }

  getCollectionALaCarteVariantArray(collectionId, isVip, isFromWebapp) {
    return this.impl.getCollectionALaCarteVariantArray(collectionId, isVip, isFromWebapp);
  }

  getCollVariant(collectionId, isVip, isFromWebapp) {
    return this.impl.getCollVariant(collectionId, isVip, isFromWebapp);
  }

  getProductVariant(product, isVip) {
    return this.impl.getProductVariant(product, isVip);
  }

  getVariantSelectedOption(prodVariant, optionName) {
    return this.impl.getVariantSelectedOption(prodVariant, optionName);
  }

  normalizeProductId(id) {
    return this.impl.normalizeProductId(id);
  }

  normalizeCollectionId(id) {
    return this.impl.normalizeCollectionId(id);
  }

  normalizeProductVariantId(id) {
    return this.impl.normalizeProductVariantId(id);
  }
}